import Hls from "hls.js";

function adaptiveVideo() {
  document.addEventListener('DOMContentLoaded', () => {
    let adaptiveVideos = document.querySelectorAll(
      '[data-name="adaptive-video"]'
    );
  
    adaptiveVideos.forEach((video) => {
      if (!video) {
        return;
      }
  
      const videoSrc = video.getAttribute("data-source");
      if (!videoSrc) {
        return;
      }
  
      if (Hls.isSupported()) {
        const hls = new Hls({
          debug: false,
          // Optional: Set an initial starting level if needed
          startLevel: -1, // -1 lets hls.js automatically select the best level
          // Optional: Cap the maximum quality level based on conditions
          autoLevelCapping: -1, // -1 means no capping, adjust based on your needs
          //debug: true,
          enableWorker: true,
          lowLatencyMode: false,
          backBufferLength: 90
        });
  
        hls.loadSource(videoSrc);
        hls.attachMedia(video);
  
        hls.on(Hls.Events.MEDIA_ATTACHED, function () {
          video.muted = true;
          video.play();
        });
  
        hls.on(Hls.Events.LEVEL_SWITCHED, function (event, data) {
          console.log("Quality level switched to:", data.level);
        });
  
        hls.on(Hls.Events.ERROR, function (event, data) {
          console.error("HLS error:", data);
          // Additional error handling logic can be implemented here
        });
      } else if (video.canPlayType("application/vnd.apple.mpegurl")) {
        video.src = videoSrc;
        video.addEventListener("canplay", function () {
          video.muted = true;
          video.play();
        });
        video.addEventListener("error", function () {
          console.error("Video playback error");
          // Additional fallback logic can be implemented here
        });
      } else {
        console.error("HLS not supported and no native HLS support available.");
      }
    });
  });
}
export { adaptiveVideo };
